import { TranscriptionBlockData, TranscriptionWordData } from './transcription.types';

/**
 * Finds a word by id across all transcript blocks.
 */
export function findTranscriptionWord(
  blocks: TranscriptionBlockData[],
  wordId: string,
): TranscriptionWordData | undefined {
  for (const block of blocks) {
    const word = block.words.find((candidate) => candidate.id === wordId);
    if (word) {
      return word;
    }
  }

  return undefined;
}
